import React, { useEffect, useState } from 'react';
import useCars from '../../hooks/useCars';

const MyCar = () => {
     // const [cars, setCars] = useState([]);
     const [cars, setCars] = useCars([])

     /*    useEffect(() => {
             fetch('http://localhost:5000/service')
                  .then(res => res.json())
                  .then(data => setCars(data))
        }, []) */

     const handleDelete = id => {
          const remaining = cars.filter(car => car._id !== id);
          setCars(remaining);
     }
     return (
          <div className='my-4'>

               {
                    cars.map(car => <div className='manage ' key={car._id}>
                         <div>
                              <img className='img-fluid' src={car.img} alt="" />
                         </div>
                         <div className='manage-info d-flex align-items-center'>
                              <div className='manage-details me-4'>
                                   <h5>{car.name}</h5>
                                   <p>{car.description}</p>
                                   <h6> Price $ {car.price}</h6>
                              </div>
                              <div className=" w-25 sm-w-100">
                                   <button className=' btn btn-danger' onClick={() => handleDelete(car._id)}>DELETE </button>

                              </div>
                         </div>
                    </div>)
               }

          </div>
     );
};

export default MyCar;